module.exports = __webpack_public_path__ + "static/media/brand-13.955decc7.png";